import React, { memo, useCallback } from 'react';

import { Box, Button, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

import { LoanFeesTestIds } from '../../../../LoanFees.testIds';
import { buttonContentStyles, sessionActionsStyles } from '../../FeeRecommendationsPanel.styles';

const SessionReviewActions = ({
  sessionId,
  pendingItemIds,
  isDisabled = false,
  isAccepting = false,
  onAcceptAll,
  onRejectAll,
}) => {
  const onClickAcceptAll = useCallback(
    () => onAcceptAll(sessionId, pendingItemIds),
    [onAcceptAll, sessionId, pendingItemIds],
  );
  const onClickRejectAll = useCallback(() => onRejectAll(sessionId), [onRejectAll, sessionId]);

  return (
    <Box sx={sessionActionsStyles}>
      <Button
        data-testid={LoanFeesTestIds.FEE_RECOMMENDATIONS_REJECT_ALL}
        disabled={isDisabled}
        size="small"
        variant="outlined"
        onClick={onClickRejectAll}
      >
        Reject all
      </Button>
      <Button
        data-testid={LoanFeesTestIds.FEE_RECOMMENDATIONS_ACCEPT_ALL}
        disabled={isDisabled}
        size="small"
        variant="contained"
        onClick={onClickAcceptAll}
      >
        <Box sx={buttonContentStyles}>
          {isAccepting && <CircularProgress color="inherit" size={16} />}
          Accept all
        </Box>
      </Button>
    </Box>
  );
};

SessionReviewActions.propTypes = {
  sessionId: PropTypes.string.isRequired,
  pendingItemIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAcceptAll: PropTypes.func.isRequired,
  onRejectAll: PropTypes.func.isRequired,
  isAccepting: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default memo(SessionReviewActions);
